/* eslint-disable no-unused-vars */
export enum Mode {
  LIGHT = 'light',
  DARK = 'dark',
}
